import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducers/auth';
import memberReducer from './reducers/member';
import { configureStore } from '@reduxjs/toolkit';

const persistConfigAuth = {
    key: 'dentaljob-pdsoft-admin-auth',
    storage,
};
const persistConfigMember = {
    key: 'dentaljob-pdsoft-admin-member',
    storage,
};

const persistedAuthReducer = persistReducer(persistConfigAuth, authReducer);
const persistedMemberReducer = persistReducer(persistConfigMember, memberReducer);

const store = configureStore({
    reducer: {
        auth: persistedAuthReducer,
        member: persistedMemberReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);
export default store;
